import classNames from 'classnames';
import { ComponentProps, ElementType } from 'react';

export default function withClassNames<C extends ElementType = ElementType>(
    Component: C,
    ...bindClassNames: Parameters<typeof classNames>
) {
    const ComponentWithClassNames = (props: ComponentProps<C>) => {
        const { className, ...rest } = {
            ...props,
            className:
                'className' in props && typeof props.className === 'string'
                    ? props.className
                    : undefined,
        };

        return (
            <Component
                className={classNames(className, ...bindClassNames)}
                {...(rest as any)}
                /*
                 * Nothing to be proud of, casting `as any`.
                 * It's a workaround for TypeScript mumbling that `rest` is
                 * not compatible with React `LibraryManagedAttributes`.
                 * Props get lost in translation when they are handled via
                 * component type (`ElementType`) rather than directly. Rest
                 * assured - outside the HOC function lexical scope, they
                 * are inferred and forwarded correctly.
                 */
            />
        );
    };

    ComponentWithClassNames.displayName = `${
        typeof Component === 'string'
            ? Component
            : (Component?.displayName ?? Component?.name ?? 'Component')
    }WithClassNames`;

    return ComponentWithClassNames;
}
